/** React Query cache keys for the alerts feature. */
export const alertsKeys = {
  all: (agencyId: string) => ['alerts', agencyId] as const,
  list: (agencyId: string, status: string) =>
    ['alerts', agencyId, 'list', status] as const,
};
